module.exports = __webpack_public_path__ + "img/coin.06faa09.svg";